import { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

const navigation = [
  { name: 'nav.home', href: '/' },
  { name: 'nav.about', href: '/about' },
  { name: 'nav.services', href: '/services' },
  // { name: 'nav.investors', href: '/investors' }, // HIDDEN UNTIL LAUNCH
  { name: 'nav.contact', href: '/contact' },
];

export default function Header() {
  const { t } = useTranslation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 right-0 z-50" style={{ backgroundColor: '#2a2a2a' }}>
      <nav className="border-b border-gray-700">
        <div className="container-wide">
          <div className="flex items-center justify-between h-16 lg:h-20">
            {/* Logo */}
            <Link to="/" className="flex items-center gap-3">
              <div className="flex flex-col" style={{ marginTop: '-4px' }}>
                <span className="font-logo tracking-tight text-white text-[37px]">
                  5N6
                </span>
                <span className="text-[10px] tracking-widest uppercase -mt-1" style={{ color: '#e0e0e0' }}>
                  See clearly. Act decisively.
                </span>
              </div>
            </Link>

            {/* Desktop Navigation */}
            <div className="hidden lg:flex lg:items-center lg:gap-1">
              {navigation.map((item) => (
                <NavLink
                  key={item.name}
                  to={item.href}
                  className={({ isActive }) =>
                    `px-4 py-2 text-sm font-medium transition-colors ${
                      isActive
                        ? 'text-white'
                        : 'hover:text-white'
                    }`
                  }
                  style={({ isActive }) => ({
                    color: isActive ? '#ffffff' : '#e0e0e0'
                  })}
                >
                  {t(item.name)}
                </NavLink>
              ))}
            </div>

            {/* Mobile Menu Button */}
            <button
              type="button"
              className="lg:hidden p-2 hover:text-white transition-colors"
              style={{ color: '#e0e0e0' }}
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            >
              {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        <AnimatePresence>
          {mobileMenuOpen && (
            <motion.div
              initial={{ opacity: 0, height: 0 }}
              animate={{ opacity: 1, height: 'auto' }}
              exit={{ opacity: 0, height: 0 }}
              className="lg:hidden border-t border-gray-700"
              style={{ backgroundColor: '#2a2a2a' }}
            >
              <div className="container-wide py-4 space-y-1">
                {navigation.map((item) => (
                  <NavLink
                    key={item.name}
                    to={item.href}
                    onClick={() => setMobileMenuOpen(false)}
                    className={({ isActive }) =>
                      `block px-4 py-3 text-base font-medium transition-colors ${
                        isActive
                          ? 'text-white'
                          : 'hover:text-white'
                      }`
                    }
                    style={({ isActive }) => ({
                      color: isActive ? '#ffffff' : '#e0e0e0'
                    })}
                  >
                    {t(item.name)}
                  </NavLink>
                ))}
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </nav>
    </header>
  );
}
